import { Component, Input } from '@angular/core';
import { CredentialStatusLabelColor } from 'src/app/shared/models/credential/customPersonCredentialStatusDefinition.model';
import { EntityCredential } from 'src/app/shared/models/credential/entityCredential';

@Component({
  selector: 'credential-snapshot',
  templateUrl: './credential-snapshot.component.html',
  styleUrls: ['./credential-snapshot.component.scss'],
  standalone: false
})
export class CredentialSnapshotComponent {
  @Input()
  credential: EntityCredential;
  @Input()
  showName: boolean = true;

  public CredentialStatusLabelColor = CredentialStatusLabelColor;
}
